import { get } from 'lodash'
import { required, email, maxLength } from 'utils/validation'


const validate = formValues => {
  const values = formValues && formValues.awardLeaderRegistration

  let errors = {
    awardLeaderRegistration: {
      firstName: required(get(values, 'firstName')),
      lastName: required(get(values, 'lastName')),
      minAgeConfirmation: required(get(values, 'minAgeConfirmation')),
      gender: {
        value: required(get(values, 'gender.value'))
      },
      email: required(get(values, 'email')) || email(get(values, 'email')),
      emailAgain: required(get(values, 'emailAgain')),
      line1: required(get(values, 'line1')),
      zipCode: required(get(values, 'zipCode')),
      stateOrProvinceOrRegion:
        required(get(values, 'stateOrProvinceOrRegion')) ||
        maxLength(70)(get(values, 'stateOrProvinceOrRegion')),
      city: required(get(values, 'city')),
      addressCountryId: required(get(values, 'addressCountryId'))
    }
  }

  if (get(values, 'email') && get(values, 'emailAgain')) {
    if (get(values, 'email') !== get(values, 'emailAgain')) {
      errors = {
        ...errors,
        emailAgain: {
          text: "Emails don't match",
          intlKey: 'errors.emails_dont_match'
        }
      }
    }
  }

  return errors
}

export default validate
